import React, { Component, useEffect } from 'react';
import * as firebase from 'firebase';
import '../view/css/Search.css';
import { NavBarGuest, NavBarAffiliate, NavBarUser } from "../view/NavBar";
import moment from 'moment';
import { Eventfeed2 } from './eventfeed2.js'
import '../view/css/Feed.css';
import Delayed from '../view/Delayed';
import {DiscoveryView} from '../view/DiscoveryView';

export const Discovery = () => {

    const [recommendation, setRecommendation] = React.useState([]);
    const [type_1, setType] = React.useState("");
    const [userLoaded, setUserLoaded] = React.useState(false);
    const [recLoaded, setRecLoaded] = React.useState(false);
    const [interests, setInterests] = React.useState([]);
    const [subs, setSubs] = React.useState([]);
    const [check_affiliate, setisAffiliate] = React.useState(false);
    const firestore = firebase.firestore();
    const user = firebase.auth().currentUser;
    const events = firestore.collection("Event");


    const runThis = () => {
        if (user) {
            console.log(user.id);
            const db = firestore.collection("Users").doc(user.email);
            db.get().then(function (doc) {
                if (doc.exists) {
                    setInterests(doc.data().interests);
                    setSubs(doc.data().subscriptions);
                    setUserLoaded(true);
                    setType(doc.data().type);
                    if(doc.data().type == "Affiliate"){
                        setisAffiliate(true);
                    }
                    console.log(doc.data().interests)
                    console.log('user logged in');
                    console.log(doc.data().subscriptions)
                } else {
                    console.log('user not logged in');
                    interests = [];
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        }
        getRecommendation();
        console.log("check pull")

    }
    const getRecommendation = () => {
        const array_event = [];
        const array_checker = [];
        var no_subs = false;
        const today_date = moment(new Date().now);

        if (subs.length === 0) {
            no_subs = true
        }
        if (subs.length > 0 || no_subs) {
            events.get().then((data) => {
                data.forEach((doc) => {
                    if (doc.exists) {
                        var should_in = false;
                        var this_tags = doc.data().tags;

                        for (var i = 0; i < interests.length; i++) {
                            for (var j = 0; j < this_tags.length; j++) {
                                if (this_tags[j] === interests[i]) {
                                    should_in = true;
                                }
                            }
                        }

                        var test_this = array_checker.filter((e, i) => array_checker.indexOf(e) === i);
                        console.log(test_this);
                        const doccer = doc.data();
                        const start_date = moment(doccer.event_start.toDate());
                        const end_date = moment(doccer.event_end.toDate());


                        if (((start_date.isSameOrAfter(today_date)) || (end_date.isAfter(today_date))) && should_in) {
                            const aff = firestore.collection("Users").doc(doccer.Affiliate);
                            var is_in = false;
                            if (!no_subs) {
                                for (var j = 0; j < subs.length; j++) {
                                    var subs_name = subs[j];
                                    console.log(subs_name);
                                    console.log(doccer.Affiliate);
                                    if (doccer.Affiliate === subs_name) {
                                        is_in = true;
                                        console.log("this true");
                                    }
                                }
                            }
                            aff.get().then(doc => {
                                if (doc.exists && (!is_in || no_subs)) {
                                    array_event.push({
                                        title: doccer.event_title,
                                        location: doccer.location,
                                        description: doccer.description,
                                        affiliate: doccer.username,
                                        start: start_date.format("MMM D, YYYY [at] h:mm a"),
                                        end: end_date.format("MMM D, YYYY [at] h:mm a"),
                                        email: doccer.Affiliate,
                                        pictures: doccer.picture
                                    })
                                    console.log("how many times")
                                    var unique = array_event.filter((e, i) => array_event.indexOf(e) === i);

                                    setRecommendation(unique);
                                    setRecLoaded(true);
                                }
                            })
                        }
                    }
                })
            }).catch(function (error) {
                console.log("Error getting documents: ", error);
            });
        }
    }

    return (
        <DiscoveryView userLoaded={userLoaded} runThis={runThis}  type1={type_1} recommendation={recommendation} check_affiliate={check_affiliate}/>
    );

}
